import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import { DonkeyAvatar } from "@/components/DonkeyMascot";
import DonkeyBotChat from "@/components/DonkeyBotChat";

// Site-wide floating launcher for the existing DonkeyBot experience.
export default function DonkeyBotLauncher() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const panelRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  useEffect(() => { if (open) panelRef.current?.querySelector("input")?.focus(); else btnRef.current?.focus(); }, [open]);

  // Avoid redundancy on the dedicated full-page bot.
  if (pathname === "/donkeybot") return null;

  return (
    <>
      {open && (
        <div ref={panelRef} role="dialog" aria-modal="false" aria-label="DonkeyBot help chat"
          className="fixed bottom-24 right-4 sm:right-6 z-[60] w-[calc(100vw-2rem)] sm:w-[400px] max-w-[400px]"
          data-testid="donkeybot-panel">
          <div className="card-donkey rounded-2xl p-4 shadow-2xl border border-white/10 bg-donkey-bg">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2"><DonkeyAvatar size={28} /><span className="font-heading font-semibold text-donkey-warm">DonkeyBot</span></div>
              <button onClick={() => setOpen(false)} aria-label="Close DonkeyBot" className="text-donkey-grey hover:text-donkey-warm rounded focus:outline-none focus:ring-2 focus:ring-donkey-orange" data-testid="donkeybot-close"><X className="w-5 h-5" /></button>
            </div>
            <DonkeyBotChat heightClass="h-[46vh] sm:h-[360px]" />
          </div>
        </div>
      )}
      <button ref={btnRef} onClick={() => setOpen((o) => !o)}
        aria-label={open ? "Close DonkeyBot" : "Open DonkeyBot help"} aria-expanded={open}
        className="fixed bottom-4 right-4 sm:right-6 z-[60] w-14 h-14 rounded-full bg-donkey-orange text-donkey-black shadow-xl flex items-center justify-center hover:scale-105 transition-transform focus:outline-none focus:ring-2 focus:ring-donkey-orange focus:ring-offset-2 focus:ring-offset-donkey-bg"
        data-testid="donkeybot-launcher">
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
      </button>
    </>
  );
}
